import * as React from "react"
import Svg, { Path } from "react-native-svg"
const DownloadFile = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#fff"
      d="M11.29 17.71a1 1 0 0 0 1.42 0l5-5a1.003 1.003 0 0 0-.326-1.638 1.005 1.005 0 0 0-1.094.218L13 14.59V3a1 1 0 0 0-2 0v11.59l-3.29-3.3a1.004 1.004 0 0 0-1.42 1.42l5 5ZM17 20H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"
    />
  </Svg>
)
export default DownloadFile
